export { default, useDefaultProps } from "./DefaultPropsProvider.mjs";